/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Minimal candidate fields. Excludes ``pdl_id`` / ``source`` per AGENTS.md.
 */
export interface CandidateMini {
  id: string;
  full_name: string;
  avatar_url?: string | null;
  linkedin_url?: string | null;
  timezone?: string | null;
}
